import { render, staticRenderFns } from "./SearchResultsCompany.vue?vue&type=template&id=30fbf471&scoped=true&"
import script from "./SearchResultsCompany.vue?vue&type=script&lang=js&"
export * from "./SearchResultsCompany.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsCompany.vue?vue&type=style&index=0&id=30fbf471&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fbf471",
  null
  
)

export default component.exports